var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.title,
        width: "90%",
        "close-on-click-modal": false,
        "append-to-body": true,
      },
      on: {
        close: function ($event) {
          return _vm.handleClose()
        },
        open: function ($event) {
          return _vm.handleOpen()
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "postForm",
          staticClass: "form-container",
          attrs: { model: _vm.postForm, rules: _vm.rules },
        },
        [
          _c(
            "sticky",
            { attrs: { "z-index": 10 } },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticStyle: { "margin-left": "10px" },
                  attrs: { type: "success" },
                  on: { click: _vm.submitForm },
                },
                [_vm._v(" Save ")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "createPost-main-container" },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-bottom": "40px" },
                          attrs: { prop: "title" },
                        },
                        [
                          _c(
                            "material-input",
                            {
                              attrs: {
                                maxlength: 100,
                                name: "name",
                                required: "",
                              },
                              model: {
                                value: _vm.postForm.title,
                                callback: function ($$v) {
                                  _vm.$set(_vm.postForm, "title", $$v)
                                },
                                expression: "postForm.title",
                              },
                            },
                            [_vm._v(" Title ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.postForm.id
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-bottom": "40px" },
                              attrs: { prop: "id" },
                            },
                            [
                              _c(
                                "material-input",
                                {
                                  attrs: {
                                    maxlength: 100,
                                    readonly: "",
                                    name: "id",
                                    required: "",
                                  },
                                  model: {
                                    value: _vm.postForm.id,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.postForm, "id", $$v)
                                    },
                                    expression: "postForm.id",
                                  },
                                },
                                [_vm._v(" ID ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-bottom": "30px" },
                  attrs: { prop: "content" },
                },
                [
                  _vm.tinymceActive
                    ? _c("tinymce", {
                        ref: "editor",
                        attrs: { height: 400 },
                        model: {
                          value: _vm.postForm.content,
                          callback: function ($$v) {
                            _vm.$set(_vm.postForm, "content", $$v)
                          },
                          expression: "postForm.content",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }